import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_LMS_API_URL } from "../../../Constants/baseConstant";
import { getDomain } from "../../Base/helper/baseFunctions";


export const GetAttendancePermissionHelper = async () => {
    return await axiosInstance(`/lms/getAttendancePermission`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain()
        }
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateAttendancePermissionHelper = async (params) => {
    toast.info("Updating...")
    return await axiosInstance(`/lms/updateAttendancePermission`, {
        method: "PUT",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            monthly_permission_count: params?.monthly_permission_count || 0,
            monthly_permission_hours: params?.monthly_permission_hours || 0,
            daily_permission_hours: params?.daily_permission_hours || 0,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Permission updated successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}
